var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrisis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54176 11.4294L11.3368 5.58009L19.5706 5.54177L25.4199 11.3368L25.4582 19.5707L19.6632 25.4199L11.4294 25.4582L5.58008 19.6632L5.54176 11.4294Z",
    fill: "#EE220C",
    stroke: "#EE220C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.806 20.834V19.1765H16.6135V20.834H14.806ZM14.806 18.134V10.034H16.6135V18.134H14.806Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrisis);
export default __webpack_public_path__ + "static/media/crisis.369c8c4e4b6dff6d3cab39bf51d109a4.svg";
export { ForwardRef as ReactComponent };